import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "containerPlayer",
    ref: "containerPlayer",
    style: _normalizeStyle(_ctx.loaded ? 'opacity: 1' : 'opacity:0')
  }, null, 4);
}